import { inflate } from 'pako'

/**
 * Converts a Base64 string to a Uint8Array.
 * Equivalent to Node's Buffer.from(str, 'base64') for decompression.
 *
 * @param {string} base64 - The Base64 string.
 * @returns {Uint8Array}
 */
export function base64ToUint8Array(base64: string): Uint8Array {
   const binary_string = atob(base64)
   const len = binary_string.length
   const bytes = new Uint8Array(len)
   for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i)
   }
   return bytes
}

/**
 * Decompresses a Base64 encoded string using pako (gzip) and decodes it to a JSON string.
 * This function is suitable for **Browser/React** environments.
 *
 * @param {string} compressedBase64Str - The Base64 encoded compressed string.
 * @returns {string} The decompressed JSON string.
 * @throws {Error} If decompression fails or the decompressed data is not valid JSON.
 */
export function decompressJsonForBrowser(compressedBase64Str: string): string {
   try {
      if (
         !compressedBase64Str ||
         compressedBase64Str == '{}' ||
         compressedBase64Str == '' ||
         compressedBase64Str == null ||
         compressedBase64Str == 'null'
      )
         return '{}'

      // Convert the Base64 string back to a Uint8Array using browser native functions
      const decoded = base64ToUint8Array(compressedBase64Str)

      // Decompress the Uint8Array using pako.inflate
      // The result is an ArrayBuffer/Uint8Array depending on pako settings, but a Uint8Array is standard.
      const decompressed = inflate(decoded)

      // Convert the decompressed Uint8Array back to a string using TextDecoder
      // TextDecoder is supported in modern browsers.
      const decoder = new TextDecoder()
      const jsonString = decoder.decode(decompressed)

      return jsonString
   } catch (error: unknown) {
      console.error('Browser Decompression failed:', error)
      // Be careful with error handling in async React code (e.g., within a promise/fetch chain)
      throw new Error(
         'Decompression failed: ' +
            (error instanceof Error ? error.message : String(error)),
      )
   }
}
